import qrcode from 'qrcode-generator';
import { useMemo } from 'react';

/** Renders text as a crisp SVG QR code (scales to any size, prints well). */
export function QrCode({ value, size = 240, label }: { value: string; size?: number; label?: string }) {
  const { path, count } = useMemo(() => {
    const qr = qrcode(0, 'M');
    // Byte mode expects one char per byte: pass UTF-8 bytes so non-ASCII survives.
    qr.addData(String.fromCharCode(...new TextEncoder().encode(value)), 'Byte');
    qr.make();
    const n = qr.getModuleCount();
    let d = '';
    for (let y = 0; y < n; y++) {
      for (let x = 0; x < n; x++) if (qr.isDark(y, x)) d += `M${x} ${y}h1v1h-1z`;
    }
    return { path: d, count: n };
  }, [value]);

  const margin = 4;
  const box = count + margin * 2;
  return (
    <svg
      className="qr"
      width={size}
      height={size}
      viewBox={`${-margin} ${-margin} ${box} ${box}`}
      role="img"
      aria-label={label ?? 'QR code'}
      shapeRendering="crispEdges"
    >
      <rect x={-margin} y={-margin} width={box} height={box} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
